import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import {
  validateDatetimeRuleValue,
  validateFormulaQuestions,
  validateInformationNode,
  validateLabelCheckQuestions,
  validateQuestionAnswerOptions,
  validateQuestionNameLength,
  validateQuestionScale,
  validateResponseType,
  validateResponseURLs,
  validateSectionNameLength,
  validateTimeMeasurementQuestions,
} from './questionValidations'
import {
  validateExcelConversionLabel,
  validateMasterSelection,
  validatePageHasQuestion,
  validatePageNameLength,
  validateReportNamingRules,
  validateTemplateHints,
  validateTemplateName,
  validateTemplatePages,
} from './templateValidations'
import {
  validateDateTimeTraceKey,
  validateRepeatSectionTraceKey,
  validateResponseSetTraceKey,
  validateTextTraceKey,
  validateTraceKeyCount,
} from './traceKeyValidations'
import { ValidateParams, ValidationError, ValidationResult } from './types'

// パイプライン用のバリデーター型
type Validator = () => ValidationResult

// アダプター層: ValidateParamsから必要なパラメータを抽出して各バリデーション関数に渡す
const createValidators = (p: ValidateParams): Validator[] => {
  const templateNodes: TemplateNodeSchema[] = Object.values(
    p.templatePagesData.templateNodes,
  )
  return [
    // ひな形関連
    () => validateTemplateName(p.templateData),
    () => validateTemplateHints(p.templateHints),
    () => validateExcelConversionLabel(p.templateData, templateNodes),
    () => validateTemplatePages(p.templatePagesData),
    () => validatePageHasQuestion(p.templatePagesData),
    () => validatePageNameLength(p.templatePagesData),
    () => validateReportNamingRules(p.templatePagesData),
    () => validateMasterSelection(p.templateData),

    // 質問関連
    () => validateResponseType(templateNodes),
    () => validateInformationNode(templateNodes),
    () => validateResponseURLs(templateNodes),
    () => validateQuestionNameLength(templateNodes),
    () => validateSectionNameLength(templateNodes),
    () => validateQuestionScale(templateNodes),
    () => validateDatetimeRuleValue(templateNodes),
    () => validateFormulaQuestions(p.templatePagesData),
    () => validateLabelCheckQuestions(p.templatePagesData),
    () => validateTimeMeasurementQuestions(p.templatePagesData),
    () => validateQuestionAnswerOptions(templateNodes, p.masterFieldDefs),

    // 検索キー関連
    () => validateRepeatSectionTraceKey(p.templatePagesData.templateNodes),
    () => validateTraceKeyCount(p.templatePagesData.templateNodes),
    () =>
      validateResponseSetTraceKey(
        p.templatePagesData.templateNodes,
        p.traceKeys,
      ),
    () =>
      validateDateTimeTraceKey(p.templatePagesData.templateNodes, p.traceKeys),
    () => validateTextTraceKey(p.templatePagesData.templateNodes, p.traceKeys),
  ]
}

/**
 * バリデーションパイプラインを実行
 * 全てのバリデーションを実行し、失敗したバリデーションのエラーを収集する
 */
export const runValidations = (params: ValidateParams): ValidationError[] => {
  const validators = createValidators(params)

  return validators
    .map(validator => validator())
    .filter(result => !result.isOk)
    .map(result => result.error)
}
